module.exports = __webpack_public_path__ + "static/media/boltOff_118.a2aca776.png";